import $ from 'jquery';
import 'slick-carousel';

const sliderSingleProductGallery = () => {
	const init = () => {
		exec();
	};

	const exec = () => {
		const el = {
			parent: '.mi-singleProduct__gallery',
			target: '.mi-singleProduct__gallery .woocommerce-product-gallery .woocommerce-product-gallery__wrapper',
		};

		if ($(el.parent).length === 0) return;

		$(document).ready(function () {
			$(el.target).slick({
				dots: false,
				infinite: false,
				speed: 400,
				slidesToShow: 1,
				slidesToScroll: 1,
				swipe: true,
				prevArrow: `<div class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
				<path d="M11.6799 0.75L17.7499 6.82L11.6799 12.89" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M0.75 6.82007H17.58" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
				</svg></button>`,
				nextArrow: `<div class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
				<path d="M11.6799 0.75L17.7499 6.82L11.6799 12.89" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M0.75 6.82007H17.58" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
				</svg></button>`,
			});
		});
	};

	init();
};

try {
	sliderSingleProductGallery();
} catch (e) {
	console.error(e);
}
